export default "__VITE_ASSET__5345ec13__"